<template>
   <v-card  flat >
          <v-layout row wrap>
            <v-flex xs3 centered>
              <v-flex xs12 pt-1 pl-1>
                <v-img v-if="picture" :src="picture" aspect-ratio="1.5" ></v-img>
                <v-img v-else src="/img/img_not_found.png" aspect-ratio="1.5" contain></v-img>
              </v-flex>
            </v-flex>
            <v-flex xs1>
            </v-flex>
            <v-flex xs7>
                <v-layout row wrap justify-start v-if="product.serial_number">
                  <v-flex xs6 md3>
                    <div class="caption grey--text">Serie</div>
                    <div class=""><span class="orange--text" v-if="product.pair">(P) </span>{{product.serial_number}}</div>
                  </v-flex>
                  <v-flex xs6 md2>
                    <div class="caption grey--text">Marca</div>
                    <div class="">{{product.maker_name}}</div>
                  </v-flex>
                  <v-flex xs6 md3>
                    <div class="caption grey--text">Descripción</div>
                    <div class="">{{product.description}}</div>
                  </v-flex>
                  <v-flex xs6 md3 v-if="product.reference_1">
                    <div class="caption grey--text"></div>
                    <div class="">{{product.reference_1}}</div>
                  </v-flex>
                  <v-flex xs6 md3 v-if="product.reference_2">
                    <div class="caption grey--text"></div>
                    <div class="">{{product.reference_2}}</div>
                  </v-flex>
                  <v-flex xs6 md3 class="text-xs-center">
                    <div class="caption grey--text">Peso</div>
                    <div class="">{{product.weigth_grams | currency('', 0)}} gr</div>
                  </v-flex>
                  <v-flex xs5 md3 class="mt-2 mr-2 pr-3">
                    <div right class="font-weight-black text-xs-right" :style="{color: currentList.color}">{{product.pesos_price * currentListPercentage| currency }}</div>
                    <v-icon v-if="hasRole('HISTORY')" @click="loadHistoryPrices(product)">history</v-icon>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-start v-if="hasRole('ADMINISTRATOR')  && product.serial_number">
                  <v-flex xs5 md2>
                    <div class="caption grey--text">Precio Dolares</div>
                    <div class="">{{product.dollar_price | currency}}</div>
                    <router-link :to="{ path: '/images', query: { img: picture }}">Imagen</router-link>
                  </v-flex>
                  <v-flex xs5 md2>
                    <div class="caption grey--text">Pais</div>
                    <div class="">{{product.country_name}}</div>
                  </v-flex>
                </v-layout>
                <v-flex xs12 py-1
                  class="text-xs-center"
                  v-if="hasRole('ADMINISTRATOR') || hasRole('USER') || currentType ==='USER' ">
                    <a color="success" @click="$emit('findSimilar', product.picture_path)">Ver similares</a>
                </v-flex>

              </v-flex>
              <!--v-flex  xs1 @click="selectProduct(product)" v-if="selectedFilter.id != 2">
                <v-layout align-center justify-center row fill-height>
                  <v-icon color="green">keyboard_arrow_right</v-icon>
                </v-layout>
              </v-flex-->
          </v-layout>
          <v-divider></v-divider>
        </v-card>
</template>
<script>

import productCardUtilitesMixin from '../../mixins/productCardUtilitesMixin';
import { cachiosInstance } from '../../axios';

export default {
  name: 'product-row',
  props: ['product'],
  mixins: [productCardUtilitesMixin],
  data() {
    return {
      picture: '',
    };
  },
  watch: {
    product: {
      handler(newValue) {
        if (newValue) {
          this.retrieveImage();
        }
      },
    },
  },
  methods: {
    async retrieveImage() {
      cachiosInstance.get(`/img/${this.product.picture_path}`)
        .then( (result) => {
          this.picture = result.data;
        })
        .catch( (error) => {
          this.$emit('no-picture', this.product);
        });
    },
    loadHistoricPrices(product) {
      this.$emit('loadHistoricPrices', product);
    },
  },

  mounted() {
    if (this.product.picture_path) {
      this.retrieveImage();
    }
  },
};
</script>

<style scoped>
  .rounded-card{
    border-radius:6px;
  }
</style>